import { useState } from 'react'
import { Card, Button } from '../../ui'
import ChangePassword from './ChangePassword'

const SecuritySettings = () => {
  const [showChangePassword, setShowChangePassword] = useState(false)

  return (
    <div className="space-y-6">
      <Card>
        <div className="p-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">Security Settings</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Two-Factor Authentication
              </label>
              <p className="text-xs text-gray-500 mb-3">
                Add an extra layer of security to your account
              </p>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium">
                Enable 2FA
              </button>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Change Password
              </label>
              <p className="text-xs text-gray-500 mb-3">
                Update your password regularly to keep your account secure
              </p>
              {!showChangePassword ? (
                <button 
                  onClick={() => setShowChangePassword(true)}
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm font-medium"
                >
                  Change Password
                </button>
              ) : (
                <button 
                  onClick={() => setShowChangePassword(false)}
                  className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition-colors text-sm font-medium mb-4"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </Card>

      {showChangePassword && (
        <ChangePassword />
      )}
    </div>
  )
}

export default SecuritySettings

